import { DataGridColDef } from '../data-grid.types';
import { CellRenderer } from '../cell-renderer';
import { getCellEditor } from './get-cell-editor';
import { DEFAULT_COLUMN_DEF } from '../constants';
import { ColDef } from 'ag-grid-community';

export const addDefaultColumnDef = (defaultColDef: DataGridColDef): ColDef => {
	return { ...DEFAULT_COLUMN_DEF, cellEditor: getCellEditor, cellRenderer: CellRenderer, ...defaultColDef };
};
